import { MarkdownBlock } from './MarkdownBlock';
import { MarkdownBuilder } from '../MarkdownBuilder';

export class MarkdownPage extends MarkdownBlock {
  protected items: MarkdownBuilder[] = [];

  /**
   * Cada elemento de la lista es un MarkdownBuilder.
   *
   * Si se pasa text como parámetro, este texto será agregado mediante
   * builder.p(text)
   */
  add(text?: string) {
    const newBuilder = new MarkdownBuilder();

    if (text) newBuilder.p(text);
    this.items.push(newBuilder);

    return newBuilder;
  }

  toString(): string {
    return `<div class="md-page">

${this.items.map((c) => c.toMarkdown()).join('\n')}

</div>`;
  }
}
